
//components
import Header from './Header';
import Products from './Products';

const Home = () => {
    return (
        <>
            <Header />
            <Products />
        </>
    )
}

export default Home;